import type { SVGProps } from 'react';

const DasWBGTSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <rect x="9" y="21" width="5" height="13" fill="currentColor" />
    <rect x="9" y="17" width="22" height="3" fill="currentColor" />
    <rect x="8" y="15" width="24" height="2" fill="currentColor" />
    <rect x="26" y="21" width="5" height="13" fill="currentColor" />
    <rect x="15" y="21" width="10" height="13" fill="currentColor" />
    <circle cx="12" cy="9" r="3" fill="currentColor" />
    <path d="M21.5 11L18.5 11L17 8L23 8L21.5 11Z" fill="currentColor" />
    <path d="M19.5 10H20.5L21 14H19L19.5 10Z" fill="currentColor" />
    <path d="M11.5 10H12.5L13 14H11L11.5 10Z" fill="currentColor" />
    <path d="M27.5 10H28.5L29 14H27L27.5 10Z" fill="currentColor" />
    <path d="M27 6H29L30 11H26L27 6Z" fill="currentColor" />
  </svg>
);
export default DasWBGTSvgIcon;
